// import React, { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faLaptop } from "@fortawesome/free-solid-svg-icons";

// import "../../styles/Footer/Footer.scss";

// const Footer = () => {
//   const [visitCount, setVisitCount] = useState(301);

//   useEffect(() => {
//     const sessionKey = "hasVisited";
//     const countKey = "visitCount";

//     // Check if the session has already recorded a visit
//     const hasVisited = sessionStorage.getItem(sessionKey);
    
//     if (!hasVisited) {
//       // If not visited, increment the count
//       const count = localStorage.getItem(countKey);
//       const newCount = count ? parseInt(count) + 1 : 301;

//       // Update local storage
//       localStorage.setItem(countKey, newCount);
//       setVisitCount(newCount);

//       // Set the session visit flag
//       sessionStorage.setItem(sessionKey, "true");
//     } else {
//       // If already visited in this session, just get the count
//       const count = localStorage.getItem(countKey);
//       setVisitCount(count ? parseInt(count) : 0);
//     }
//   }, []);

//   return (
//     <div className="footer">
//       <div className="footer__container">
//         <p>
//           Made <FontAwesomeIcon icon={faLaptop} size="sm" /> by Ajay Kumar
//         </p>
//         <p>Views: {visitCount}</p>
//       </div>
//     </div>
//   );
// };

// export default Footer;


import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLaptop } from "@fortawesome/free-solid-svg-icons";

import "../../styles/Footer/Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__container">
        <p>
          Made <FontAwesomeIcon icon={faLaptop} size="sm" /> by Ajay Kumar
        </p>
      </div>
    </div>
  );
};

export default Footer;
